module.exports = __webpack_public_path__ + "img/logo.8a110f6e.svg";